export default __webpack_public_path__ + "static/media/reward.f6ff0269.jpg";